export enum FilterProviderKey {
	FILTER_PROVIDER = 'searchFilters.filterProvider',
	CURRENCY_FILTER_PROVIDER = 'searchFilters.currencyFilterProvider',
	LOCATION_FILTER_PROVIDER = 'searchFilters.locationFilterProvider',
	UNIVERSITY_FILTER_PROVIDER = 'searchFilters.universityFilterProvider',
	CONFIGURATION = 'searchFilters.configuration',
}
